const getAltTextValue = currentImageAsDomElement => {
  try {
    const imgEl = currentImageAsDomElement;
    return imgEl.alt;
  } catch (error) {
    return null;
  }
};
export default getAltTextValue;